import translations from './translations'

translations.add('es', {
    headerMessage: '¿Seguro que desea cancelar?',
    no: 'NO',
    yes: 'SÍ'
})
